import {EventPrefix} from "../constants";

export function publishEvent<T>(eventName: string, detail?: T) {
  document.dispatchEvent(
    new CustomEvent(EventPrefix + eventName, {detail})
  );
}